import { useCallback, useEffect, useState } from "react";
import { apiClient } from "./apiClient";
import type { CurrentUser } from "./types";

interface UseCurrentUserResult {
  user: CurrentUser | null;
  loading: boolean;
  error: unknown;
  refresh: () => Promise<void>;
}

/** GET /api/me → { id, email, displayName, permissions }. */
export function useCurrentUser(): UseCurrentUserResult {
  const [user, setUser] = useState<CurrentUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const data = await apiClient<CurrentUser>("/api/me");
      setUser(data);
      setError(null);
    } catch (err) {
      setUser(null);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { user, loading, error, refresh };
}
